import meter1 from "../assets/img/logo-javascript.svg";
import meter2 from "../assets/img/css-3.svg";
import meter3 from "../assets/img/react-2.svg";
import meter4 from "../assets/img/java-14.svg";
import meter5 from "../assets/img/html-1.svg";
import meter6 from "../assets/img/nodejs-icon.svg";
import meter7 from "../assets/img/c--4.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/skillsfooter2.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 4,
    },
    laptop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 576 },
      items: 3,
    },
    mobileLarge: {
      breakpoint: { max: 576, min: 400 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 400, min: 0 },
      items: 1,
    },
  };

  const skills = [
    { src: meter3, alt: "react-icon", label: "React" },
    { src: meter1, alt: "javascript-icon", label: "JavaScript" },
    { src: meter5, alt: "html-icon", label: "HTML" },
    { src: meter2, alt: "css-icon", label: "CSS" },
    { src: meter6, alt: "node-icon", label: "Node.JS" },
    { src: meter4, alt: "java-icon", label: "Java" },
    { src: meter7, alt: "c#-icon", label: "C#" },
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>
                Hier ist ein kurzer Überblick über einige der
                Programmiersprachen, <br /> mit denen ich täglich arbeite oder
                aktiv in Projekten verwendet habe.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                swipeable={true}
                draggable={true}
                className="owl-carousel owl-theme skill-slider"
              >
                {skills.map((skill) => (
                  <div className="item" key={skill.label}>
                    <img src={skill.src} alt={skill.alt} />
                    <h5 style={{ marginTop: "20px" }}>{skill.label}</h5>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img
        className="background-image-left"
        src={colorSharp}
        alt="background-left"
      />
    </section>
  );
};
